// Форма и элементы
const form = document.forms.form;
const checkbox = form.querySelector('.form__checkbox');
const nameInput = form.elements.name;
const tel = form.elements.tel;
const question = form.elements.question;
const button = form.querySelector('.form__button');
// Окно "Спасибо"
const popup = document.querySelector('.popup');

// Валидация
// функция, показывающая статус валидности поля
function checkInputValidity(input) {
  let isValid = true;
  if (input.validity.valueMissing) {
    isValid = false;
  } else if (input.validity.patternMismatch) {
    isValid = false;
  }
  return isValid
}
// функция, меняющая состояние кнопки сабмита
function setSubmitButtonState(button, status) {
  if (status === true) {
    button.classList.remove('form__button_disabled');
    button.classList.add('form__button_enabled');
    button.classList.remove('disabled');
  } else {
    button.classList.add('disabled');
  }
}

//Отображение ошибок
function validateInputs(input, error) {
  function addError() {
    error.classList.remove('form__error_not-active');
    error.classList.add('form__error_active');
    input.classList.add('form__input_error');
  }

  if (input.classList.contains('form__text')) {
    input.classList.add('form__input_fill');
    return;
  }

  if (input.validity.valueMissing) {
    if (input.name === 'name') {
      error.textContent = 'Не забудьте ввести имя';
    } else {
      error.textContent = 'Обязательно для заполнения';
    }
    addError();
  } else if (input.validity.patternMismatch) {
    addError();
    error.textContent = 'Неверный формат';
  } else {
    error.classList.remove('form__error_active');
    error.classList.add('form__error_not-active');
    input.classList.remove('form__input_error');
    input.classList.add('form__input_fill');
    error.textContent = '';
  }
}

// проверка полей формы на валидность
function checkValid() {
  let isFormValid = true;
  // const button = form.querySelector('.form__button');

  const name = form.elements.name;
  const tel = form.elements.tel;
  checkInputValidity(name);
  checkInputValidity(tel);
  // checkInputValidity(checkbox);
  if (checkInputValidity(name) && checkInputValidity(tel)) {
    setSubmitButtonState(button, isFormValid);
  } else {
    isFormValid = false;
    setSubmitButtonState(button, isFormValid);
  }
}


// валидация полей формы при переключении фокуса на полях
function checkInput(event) {
  const error = event.target.nextElementSibling;
  const input = event.target;
  validateInputs(input, error)
}

// состояние чекбокса и его валидация
function setStageCheckbox(event) {
  const check = event.target;
  const checkbox = event.target.nextElementSibling;

  checkbox.classList.toggle('form__checkbox_checked'); 
  if (checkbox.classList.contains('form__checkbox_checked')) {
    check.checked = true;
    checkValid();
    checkbox.parentElement.classList.remove('form__checkbox_error');
    checkbox.parentElement.nextElementSibling.classList.remove('form__error_active');
    checkbox.parentElement.nextElementSibling.classList.add('form__error_not-active');
  } else {
    check.checked = false;
    setSubmitButtonState(button, check.checked);
    checkbox.parentElement.classList.add('form__checkbox_error');
    checkbox.parentElement.nextElementSibling.classList.remove('form__error_not-active');
    checkbox.parentElement.nextElementSibling.classList.add('form__error_active');
  }
}

// открытие окна "Спасибо"
function openPopup() {
  popup.classList.add('popup_is-opened');

  const buttonOk = popup.querySelector('.form__popup-button');
  const buttonClose = popup.querySelector('.form__popup-close');

  buttonOk.addEventListener('click', closePopup);
  buttonClose.addEventListener('click', closePopup);
}
// закрытие окна "Спасибо"
function closePopup() {
  popup.classList.remove('popup_is-opened');
}

// слушатель валидации поля "Имя"
nameInput.addEventListener('change', checkInput);
// слушатель валидации поля "Телефон"
tel.addEventListener('change', checkInput);
// слушатель валидации поля "Вопрос"
question.addEventListener('change', checkInput);
// слушатель состояния чекбокса
checkbox.addEventListener('click', setStageCheckbox);

// слушатель валидации полей формы, если активен чекбокс
form.addEventListener('input', () => {
  if (checkbox.checked) {
    checkValid();
  }
});

// Функционал кнопки
button.addEventListener('click', (event) => {
  event.preventDefault();
  // если поля не заполнены или неверно заполнены
  if (button.classList.contains('disabled')) {
    // выдаем ошибки под полями
    validateInputs(nameInput, nameInput.nextElementSibling)
    validateInputs(tel, tel.nextElementSibling)
    // ошибка под чекбоксом
    if (!checkbox.nextElementSibling.classList.contains('form__checkbox_checked')) {
      checkbox.parentElement.classList.add('form__checkbox_error');
      checkbox.parentElement.nextElementSibling.classList.remove('form__error_not-active');
      checkbox.parentElement.nextElementSibling.classList.add('form__error_active');
    } else {
      checkbox.parentElement.classList.remove('form__checkbox_error');
      checkbox.parentElement.nextElementSibling.classList.add('form__error_not-active');
      checkbox.parentElement.nextElementSibling.classList.remove('form__error_active');
    }
    // меняем состояние кнопки, делая её неактивной
    button.classList.add('form__button_disabled');
    button.classList.remove('form__button_enabled');
  } else {
    // данные для передачи
    const name = nameInput.value;
    const phone = tel.value;
    const text = question.value;
    // возвращаем форму к исходному состоянию
    checkbox.nextElementSibling.classList.remove('form__checkbox_checked');
    setSubmitButtonState(button, false);
    button.classList.remove('form__button_disabled_focus');
    nameInput.classList.remove('form__input_fill');
    tel.classList.remove('form__input_fill');
    question.classList.remove('form__input_fill');
    checkbox.checked = false;
    // сбрасываем поля формы
    form.reset();
    // открываем окно "Спасибо"
    openPopup();
  } 
})

